import React from "react";
import { Grid, TextField, Button, Typography } from "@mui/material";
import ModalLayout from "components/ModalLayout";
import MDButton from "components/MDButton";
import CancelButton from "components/CancelButton";

const imagePicker = (id, label, file, onFileChange) => (
  <Grid item xs={12} sm={6}>
    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
      <input
        type="file"
        id={id}
        onChange={onFileChange}
        style={{ display: "none" }}
      />
      <label htmlFor={id}>
        <Button variant="outlined" component="span" sx={{ width: "100%", color: "gray" }}>
          {label}
        </Button>
      </label>
      {file && (
        <img
          src={file}
          alt="Preview"
          style={{ width: 100, height: "auto", borderRadius: 8, border: "1px solid #e5e7eb" }}
        />
      )}
    </div>
  </Grid>
);

const SliderFormModal = ({
  open,
  isEditing,
  sliderData,
  onClose,
  onInputChange,
  onFileChange,
  onSubmit,
}) => {
  return (
    <ModalLayout
      open={open}
      onClose={onClose}
      title={isEditing ? "Update Slider" : "Add Slider"}
      subtitle="Marketing Slider"
      maxWidth={900}
      headerContent={
        <Typography variant="body2" color="text.secondary" mt={1}>
          Configure multilingual titles and attach localized slider artwork.
        </Typography>
      }
      actions={
        <>
          <CancelButton onClick={onClose} />
          <MDButton
            type="submit"
            form="slider-form"
            variant="gradient"
            color="info"
            sx={{ minWidth: 140 }}
          >
            {isEditing ? "Update" : "Create"}
          </MDButton>
        </>
      }
    >
      <form id="slider-form" onSubmit={onSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Title (EN)"
              name="name_en"
              value={sliderData.name_en}
              onChange={onInputChange}
              margin="normal"
              required
              InputProps={{ sx: { borderRadius: 2 } }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Title (FR)"
              name="name_fr"
              value={sliderData.name_fr}
              onChange={onInputChange}
              margin="normal"
              required
              InputProps={{ sx: { borderRadius: 2 } }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Description (EN)"
              name="description_en"
              value={sliderData.description_en}
              onChange={onInputChange}
              margin="normal"
              multiline
              rows={3}
              InputProps={{ sx: { borderRadius: 2 } }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Description (FR)"
              name="description_fr"
              value={sliderData.description_fr}
              onChange={onInputChange}
              margin="normal"
              multiline
              rows={3}
              InputProps={{ sx: { borderRadius: 2 } }}
            />
          </Grid>

          {imagePicker(
            "file-input-en",
            "Upload Image (EN)",
            sliderData.image_en_preview,
            (e) => onFileChange(e, "image_en")
          )}

          {imagePicker(
            "file-input-fr",
            "Upload Image (FR)",
            sliderData.image_fr_preview,
            (e) => onFileChange(e, "image_fr")
          )}
        </Grid>
      </form>
    </ModalLayout>
  );
};

export default SliderFormModal;
